/**
 * Created by ObadaDarwish on 27/05/2018.
 */

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'limitNgFor',
pure:false})

export class limitNgFor implements PipeTransform {


  transform(items: any, number: number): any {
    if (items) {
      return items.filter((item, index) => index < number );
    }
    else {
      return items;
    }
  }

}
